<template>
  <el-dialog
    v-dialogDrag
    title="新增通知"
    :visible="visible"
    width="60%"
    @open="open"
    @close="close"
    :close-on-click-modal="false"
  >
    <el-row :gutter="20" class="form_body">
        <el-col :span="24">
          <p class="form_title">黑名单添加</p>
          <el-form
            v-loading="loading"
            element-loading-text="请稍候..."
            label-width="100px"
            class="operation"
            :model="form"
            ref="form"
          >   
                  <el-form-item label="黑名单类型：" prop="status">
                    <el-select
                      v-model="form.type"
                      placeholder="请选择"
                      size="medium"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
            
                <el-form-item label="车牌号" prop="carNo">
                  <el-input type="text" size="medium" v-model="form.carNo" placeholder=""/>
                </el-form-item>

                <el-form-item label="描述" prop="remark">
                  <el-input type="textarea" size="medium" v-model="form.note" placeholder="请输入描述"/>
                </el-form-item>
              
              <el-col :xs="8" :sm="12" class="text-right">
                <el-button size="medium" @click="close" type="default">取消</el-button>
                <el-button size="medium" @click="submitForm('form')" type="primary">保存</el-button>
              </el-col>
            
          </el-form>
        </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import dialog from '@/components/mixins/dialog'
import EditorTinymce from '@/components/common/EditorTinymce'
import {getBlackType,addBlackCar} from "./api/index"
export default {
  mixins: [dialog],
  data() {
    return {
      form: {
      },
      options: [
        
      ],
    };
  },
  methods: {
    submitForm(){
      let data = Object.assign({},this.form);
      addBlackCar(data)
        .then((res) => {
          this.$emit('success');
        })
        .catch((err) => {
          this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
        });
    },
    getBlackType(){
      getBlackType('1011')
        .then((res) =>{
          this.options = res.data.data;
        })
    },
  },
  mounted(){
    this.getBlackType();
  },
  components:{EditorTinymce}
}
</script>
<style scoped>
.text-right{
  text-align:right;
}
.form_title {
  border-left: 5px solid #409eff;
  margin: 0;
  padding: 0 0 0 10px;
  margin-bottom: 15px;
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  text-align: left;
  color: #666666;
  font-size: 14px;
  height: 22px;
  line-height: 22px;
}
</style>


